<form [formGroup]="form">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group validateMe d-block">
        <label class="form-label" for="Link">{{'lang.globals.link' | translate}}</label>
        <div class="d-flex">
          <input class="form-control flex-grow-1 mr-2" formControlName="Link" id="Link" sbAutofocus type="text">
          <button [disabled]="attachment && attachment.id" class="btn btn-default">
            <sb-icon (click)="pasteDataFromClipboard()" class="cursor-pointer" icon="paste"></sb-icon>
          </button>
        </div>
        <span class="form-text text-muted">{{'lang.globals.urlDescription' | translate}}</span>
        <div *ngIf="Link.touched && Link.errors?.required" class="alert alert-danger">
          {{'lang.globals.notEmpty' | translate}}</div>
        <div *ngIf="Link.touched && Link.errors?.pattern" class="alert alert-danger">
          {{'lang.globals.wrongUrlPattern' | translate}}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Title">{{'lang.globals.title' | translate}}</label>
        <input class="form-control" formControlName="Title" id="Title"
               type="text">
        <div *ngIf="Title.touched && Title.errors?.required" class="alert alert-danger">
          {{'lang.globals.notEmpty' | translate}}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
        <input class="form-control" formControlName="Description" id="Description" type="text">
        <div *ngIf="Description.touched && Description.errors?.required" class="alert alert-danger">
          {{'lang.globals.notEmpty' | translate}}</div>
      </div>
    </div>
    <div *ngIf="attachment && attachment.id" class="col-md-12">
      <div class="form-group validateMe">
        <label class="form-label" for="DisplayTypeForm">{{'lang.globals.displayTypeForm' | translate}}</label>
        <select class="form-select" formControlName="DisplayTypeForm" id="DisplayTypeForm">
          <option *ngFor="let opt of displaySelection" [value]="opt">{{opt}}</option>
        </select>
        <span class="form-text text-muted">{{'lang.globals.displayTypeFormDescription' | translate}}</span>
      </div>
    </div>
    <div class="col-md-12">
      <button (click)="saveUrlAttachment()" [disabled]="form.invalid" class="btn btn-success ">
        <ng-container *ngIf="attachment && attachment.id">
          <sb-icon icon="save"></sb-icon>&nbsp;{{'lang.globals.save' | translate}}
        </ng-container>
        <ng-container *ngIf="attachment && !attachment.id">
          <sb-icon icon="plus"></sb-icon>&nbsp;{{'lang.globals.create' | translate}}
        </ng-container>
      </button>
    </div>
  </div>
</form>

